import { render, staticRenderFns } from "./SelectedProductElement.vue?vue&type=template&id=9fdd0066"
import script from "./SelectedProductElement.vue?vue&type=script&lang=js"
export * from "./SelectedProductElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports